function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.45455 12.9091H2V2H18.3636V9.42818",
  stroke: "#2C7BFD",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0908 12V15.6364C11.0908 17.1427 13.5326 18.3636 16.5454 18.3636C19.5581 18.3636 21.9999 17.1427 21.9999 15.6364V12",
  stroke: "#2C7BFD",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0908 15.6364V19.2727C11.0908 20.7791 13.5326 22 16.5454 22C19.5581 22 21.9999 20.7791 21.9999 19.2727V15.6364",
  stroke: "#2C7BFD",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5454 14.7273C19.5578 14.7273 21.9999 13.5062 21.9999 12C21.9999 10.4937 19.5578 9.27271 16.5454 9.27271C13.5329 9.27271 11.0908 10.4937 11.0908 12C11.0908 13.5062 13.5329 14.7273 16.5454 14.7273Z",
  stroke: "#2C7BFD",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.182 8.36359C10.6841 8.36359 11.0911 7.95658 11.0911 7.4545C11.0911 6.95242 10.6841 6.54541 10.182 6.54541C9.67996 6.54541 9.27295 6.95242 9.27295 7.4545C9.27295 7.95658 9.67996 8.36359 10.182 8.36359Z",
  stroke: "#2C7BFD",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var SvgCash = function SvgCash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash.0726381d.svg";
export { ForwardRef as ReactComponent };